import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import TestimonialsGrid from '../components/TestimonialsGrid';
import Footer from '../components/Footer';

const TestimonialsPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Testimonials | PH Therapy</title>
        <meta name="description" content="What our clients say about PH Therapy. Stories from partners, CEOs, and professionals who reclaimed their health through Clinical Exercise Physiology. London, Wimbledon, Fulham, Kensington, Chiswick, Surrey & Sussex." />
        <link rel="canonical" href="https://www.pandhtherapy.co.uk/testimonials" />
      </Helmet>
      <Header />
      <TestimonialsGrid />
      <Footer />
    </>
  );
};

export default TestimonialsPage;